import DashboardPageLoading from "./dashboard";

export default DashboardPageLoading;
